import { Component, computed, inject, input } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';

@Component({
  selector: 'wl-logo',
  standalone: true,
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.ed.scss', './logo.component.essent.scss'],
})
export class LogoComponent {
  readonly brand = inject(ENVIRONMENT_CONFIG).brand;

  /** The id of the logo */
  readonly id = input<string>();

  /** The logo variant */
  readonly variant = input<'dark' | 'light'>('dark');

  /** The width of the logo in pixels (leave empty to use the default width) */
  readonly width = input<number>();

  /** The height of the logo in pixels (leave empty to use the default height) */
  readonly height = input<number>();

  /** The title of the logo */
  readonly title = input<string>();

  public readonly showTitle = computed<boolean>(
    () => !!(this.id() && this.title())
  );
}
